import React from 'react';
import {toJS} from 'mobx';
import {inject,observer} from 'mobx-react';
import _ from 'underscore';

import './index.scss';

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress';
import CategoriesIcon from '@material-ui/icons/DeviceHub';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import {
    MuiThemeProvider,
    createMuiTheme,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@material-ui/core'

//custom components
import CustomTable from '../../../components/complex/customTable'
import Search from '../../../components/basic/search';
import CustomButton from '../../../components/basic/CustomButton';
import CustomSnackbar from '../../../components/global/snackbar';
import CustomInput from '../../../components/basic/input';
import AddCategoryOrTag from './addCategoryTag';
import ImportProducts from './import';
import DeleteDialog from '../../../components/global/deleteDialog';

//global


//other libraries
import Icon from '@mdi/react'
import {
    mdiUpload,
    mdiChevronRight,
    mdiChevronLeft,
    mdiLabel,
    mdiClose,
    mdiCloudUpload,
    mdiXml,
    mdiSettings,
} from '@mdi/js'
import queryString from 'query-string'
import uuid from 'uuid4'
import moment from 'moment';
import TreeMenu from 'react-simple-tree-menu'

//api
import {api} from '../../../functions/api'
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import AddToXmlExports from './AddToXmlExports'
import Menu from '@material-ui/core/Menu'
import PriceImportProducts from './priceImport'

const TIMEOUT = 3000;

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: "transparent !important"
            },
        },
        MuiExpansionPanelSummary: {
            root: {
                margin: "0 !important",
                minHeight: "30px !important",
                fontSize: "14px"
            },
            content: {
                margin: "6px 0 !important",
                height: "17px"
            }
        },
        MuiExpansionPanel: {
            root: {
                "&:before": {
                    backgroundColor: "none"
                }
            }
        },
        MuiIconButton: {
            root: {
                padding: "0 12px !important"
            }
        },
        MuiListItem: {
            root: {
                padding: "6px 0 !important",
                fontSize: "14px"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class ProductsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            categoryMenu: true,
            name: [],
            tags_ids: [],
            category_id: 0,
            state: "",
            priceFrom: "",
            priceTo: "",
            warehouse_status_id: "",
            import_id: "",
            tagsFromUrl: [],
            searchTerm: "",
            tag: "",
            openCategoryTagDialog: false,
            dialogType: null,
            floatButton: false,
            anchorEl: null,
            mobileCategoryList: false,
            import: false,
            priceImport: false,
            activeCategoryMobile: "",
            isProductionDialogOpened: false,
            productionDialogType: 'production',
            productionDialogStatus: true,
            openXmlExportDialog: false,
            productsActionAnchorEl: null
        }
    }

    componentDidMount() {
        this.loadProducts();
        this.props.internal.setRoute(this.props.history, this.props.location.pathname);
        this.setPermissions();
        // this.loadCategories();


        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)

        // let tagsFromUrl;
        // if(queries.tags) {
        //     tagsFromUrl = queries.tags;
        //     let tagsFromUrlArray = tagsFromUrl.split(',')
        //     this.setState({tagsFromUrl: tagsFromUrlArray})
        // }

        let price;
        if(queries.price) {
            price = queries.price;
            let priceFrom = Number(price.split(',')[0])
            let priceTo = Number(price.split(',')[1])
            this.setState({priceFrom: priceFrom, priceTo: priceTo})
        }

        let warehouse_status_id;
        if(queries.warehouse_status_id) {
            warehouse_status_id = Number(queries.warehouse_status_id);
            this.setState({warehouse_status_id: warehouse_status_id})
        }

        let import_id;
        if(queries.import_id) {
            import_id = Number(queries.import_id);
            this.setState({import_id: import_id})
        }

        let searchterm;
        if(queries.searchterm) {
            searchterm = queries.searchterm;
            this.setState({searchTerm: searchterm},)
        }

        let tag;
        if(queries.tags) {
            tag = queries.tags;
            this.setState({tag: Number(tag)},)
        }

    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

tableHeader = [
    {
        "title": "code",
        "numeric": false,
        sortBy: "code",
    },
    {
        "title": "name",
        "numeric": false,
        "min_width": "100px",
        sortBy: "name"
    },
    {
        "title": "category",
        "numeric": false,
    },
    {
        "title": "tag",
        "numeric": false
    },
    // {
    //     "title": "retail_price",
    //     "numeric": true,
    //     min_width: "80px"
    // },
    // {
    //     "title": "warehouse_status_id",
    //     "numeric": false,
    //     min_width: "110px",
    //     sortBy: "warehouse_status_id"
    // },
    // {
    //     "title": "production",
    //     "numeric": false,
    // }
];
// tableBody = ["code", "name", "category_name", "tags"]
tableBody = ["code", "name", "category_name", "tags"]
dropDownMenuItems = [
    // {
    //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
    //     url: "edit/tab=0"
    //     //action: "edit"
    // },
    {
        title: this.props.translate.i18n.GLOBAL.BUTTONS.DETAIL,
        url: "detail/"
    },
    // {
    //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
    //     //url: "delete",
    //     action: "delete"
    // }
]

    setPermissions = () => {
        let permissions = toJS(this.props.internal.user.data.permissions.products)
        const {user} = toJS(this.props.internal)

        if(user.data.role.id < 3 || user.data.role.id === 5  ) {
            this.tableBody.push('client_price')
            this.tableBody.push("warehouse_status_computed")
            this.tableHeader.push({
                "title": "retail_price",
                "numeric": true,
                min_width: "80px"
            })
            this.tableHeader.push( {
                "title": "warehouse_status_id",
                min_width: "110px",
                "numeric": true,
                sortBy: "warehouse_info"
            })
        }
        if(user.data.role.id === 5 || (permissions.store && permissions.update)) {

            this.tableBody.push(
              "retail_price_with_vat",
              "discounted_price_with_vat",
            )
            this.tableHeader.push(
              {
                  "title": "retail_price_with_vat",
                  "numeric": true,
                  min_width: "80px",
                  sortBy: "retail_price"
              },
              {
                  "title": "discounted_price_with_vat",
                  "numeric": true,
                  min_width: "80px",
                  sortBy: "discounted_price",
                  textAlign: "right"
              },
            );
        }



        if(permissions.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    url: "edit/tab=0"
                }
            )
        }

        if(permissions.manage_warehouse) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.MODULES.PRODUCTS.WAREHOUSE_MANAGE,
                    url: "edit/tab=8"
                }
            )
        }
        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                }
            )
        }
        if(permissions.store && permissions.update) {
            this.tableBody.push(
                // "retail_price_with_vat",
                // "discounted_price_with_vat",
                "import",
                "production",
                "shops_production"
            )
            this.tableHeader.push(
                // {
                //     "title": "retail_price_with_vat",
                //     "numeric": true,
                //     min_width: "80px",
                //     sortBy: "retail_price"
                // },
                // {
                //     "title": "discounted_price_with_vat",
                //     "numeric": true,
                //     min_width: "80px",
                //     sortBy: "discounted_price",
                //     textAlign: "right"
                // },
                {
                    "title": "created_at",
                    "numeric": false
                },
                {
                    "title": "production",
                    "numeric": false,
                    sortBy: "production"
                },
                {
                    "title": "shops_production",
                    "numeric": false,
                    sortBy: "shops_production"
                }
            )
        }

        //client-user, client-manager => do tabulky pridany stlpec nakupovat
        if(user.data.role.id === 3 || user.data.role.id === 4) {

            this.tableHeader.push(
                {
                "title": "warehouse_status_id",
                "numeric": false,
                min_width: "110px",
                sortBy: "warehouse_info"
            },

                {
                    "title": "buy_price",
                    numeric: true,
                    "min_width": "80px",
                    "sortBy": "client_price",
                    disabled: true
                },
                {
                    "title": "retail_price_with",
                    numeric: true,
                    "min_width": "100px",
                },

                {
                    "title": "buy_item",
                    numeric: false,
                }
            )
            this.tableBody.push("warehouse_status_computed","client_price","retail_price_with_vat","buy_item")
        }

    }

    categories = []
    loadCategories = async(searchterm = "") => {
        // this.setState({loading: true})


        let load_data = await api({
            method: 'get',
            url: 'lists/categories',
            authorization: this.props.internal.user.access_token,
            searchterm: searchterm
        })

        if(load_data.success === true) {
            // this.props.internal.setDataForTable(load_data.data)
            this.categories = load_data.data
            return true
        }
        else {
            return false
        }

    }


    loadProducts = async(size = 10, page = 0, searchterm = " ", by = "name", dir = "asc", category_id = undefined) => {
        localStorage.setItem('url', this.props.history.location.search); // ak mame zapnute filtre, aby sme sa vedeli vratit z detail produktu na list ale uz s filtrami
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        let price = []
        let tags = [];
        let warehouse_status_id = null;
        let import_id = null;

        if(queries) {

            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }

            if(queries.category_id) {
                category_id = queries.category_id
            }

            if(queries.price) {
                price = queries.price
            }

            if(queries.tags) {
                tags = queries.tags
            }

            if(queries.warehouse_status_id) {
                warehouse_status_id = queries.warehouse_status_id
            }

            if(queries.import_id) {
                import_id = queries.import_id
            }
        }

        let params = {
                searchterm: searchterm,
                page: {
                    number: page,
                    size: size
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    },
                    // {
                    //     by: by,
                    //     dir: dir
                    // },
                ],
                //"filters[category_id]":
                //"filters[tags]": [tag]
        }

        let filters = {}
        if(category_id !== undefined) {
            let tmp = []
            tmp['category_id'] = Number(category_id)
            filters.category_id = Number(category_id)

            params.filters = filters
        }

        if(price.length > 0) {

            let tmp = []

            if(price.split(',')[1] === "" && price.split(',')[0] !== ""  ) {
                let tmpRetailPrice = price;
                let tmp = tmpRetailPrice.split(',')
                // tmp[1] = 100000000
                let compareVal = tmp[0]
                tmp[0] = "gt"
                tmp[1] = compareVal
                price = tmp.join(',')
            }

            else if(price.split(',')[0] === "" && price.split(',')[1] !== "" ) {
                let tmpRetailPrice = price;
                let tmp = tmpRetailPrice.split(',')
                // tmp[0] = 0
                let compareVal = tmp[1]
                tmp[0] = "lt"
                tmp[1] = compareVal
                price = tmp.join(',')
            }

            else if(price.split(',')[0] === "" && price.split(',')[1] === "" ) {
                tmp[0] = "gte"
                price = tmp.join(',')
            }

            tmp['price'] = price.split(',')
            filters.price = tmp;
            params.filters = filters

        }

        if(tags.length > 0) {
            let tmp = []
            tmp['tags'] = tags.split(',')
            filters.tags = tmp
            params.filters = filters
        }

        if(warehouse_status_id !== null) {
            filters.warehouse_status_id = Number(warehouse_status_id)
            params.filters = filters

        }

        if(import_id !== null) {
            filters.import_id = Number(import_id)
            params.filters = filters
        }


        let load_data = await api({
            method: 'get',
            url: 'products',
            authorization: this.props.internal.user.access_token,
            params: params
        })

        // let data = new API();
        // let load_data2 = await data.api({
        //     method: 'get',
        //     url: 'products',
        //     authorization: this.props.internal.user.access_token,
        //     params: params
        // })


        // await this.loadCategories();
        if(load_data.success === true) {
            if (load_data.data) {

                for(let i=0; i<load_data.data.data.length; i++) {
                    let data = load_data.data.data[i].warehouse_status

                    let category_name;
                    if(load_data.data.data[i].category) {
                        category_name = load_data.data.data[i].category.name
                    }
                    delete load_data.data.data[i].warehouse_status;
                    load_data.data.data[i].warehouse_status_name = data.name
                    load_data.data.data[i].category_name = category_name

                    // load_data.data.lists.categories = this.categories.data
                }
                this.props.internal.setDataForTable(load_data.data)
                this.categoriesTree = load_data.data.lists.categories
                this.categoriesTree.unshift({
                    name: this.props.translate.i18n.MODULES.PRODUCTS.ALL_LEVELS,
                    children: [],
                    id: ""
                })
                this.setCategoriesTree(load_data.data.lists.categories)
            }
            this.setState({loading: false})
        }

    }

    convertTreeToList = (allData) => {
        for(let i=0; i<allData.length; i++) {
            this.oneCategory(allData[i])
        }
    }

    categories2 = []
    oneCategory = (oneItem) => {
        this.categories2.push(oneItem)
        if(oneItem.children) {
            for(let i=0; i<oneItem.children.length; i++) {
                this.oneCategory(oneItem.children[i])
            }
        }
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
        // this.addQueryToUrl("by", orderBy)
    }

    addQueryToUrl = _.debounce((param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key && queries[key] !== "") {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        // this.setState({loading: true})
        this.loadProducts(); // call only when value parameter has an actual value and is longer than 2 characters
    }, 1000);

    renderCategoryList = () => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        let toplevel = true;
        if(queries.category_id) {
            toplevel = false;
        }
        this.divForRender = []
        this.divForRender.push(
            <div
                key={uuid()}
                className={`item ${toplevel === true? ' active' : ""}`}
                onClick={() => this.handleChangeCategory("")}
            >
                <span>
                    {this.props.translate.i18n.MODULES.PRODUCTS.ALL_LEVELS}
                </span>
            </div>
        )
        this.allCategories = [];
        let categories = toJS(this.props.internal.dataForTable.lists.categories)
        for(let i=0; i<categories.length; i++) {
            this.renderCategoryItem(categories[i])
        }
        return this.divForRender

    }

    divForRender = []

    allCategories = [];

    flagCategorySet = false

    activeCateogry = null;
    activeCategoryLevel = null

    renderCategoryItem = (rowData) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        this.allCategories.push(rowData)


        if(rowData.id === Number(queries.category_id) && !this.flagCategorySet) {
            this.setState({activeCategoryMobile: rowData.name})
            this.flagCategorySet = true
        }

        this.divForRender.push(
            <div
                key={rowData.id}
                className={`icon-subcategory-${rowData.level} item ${Number(queries.category_id) === rowData.id? ' active' : ""} level-${rowData.level} category-${rowData.id}`} //${Number(queries.category_id) === this.activeCateogry ? 'active-child' : ""}
                onClick={() => this.handleChangeCategory(rowData.id)}
                id={`category-${rowData.id}`}
            >
                {/* <Icon
                    path={mdiSubdirectoryArrowRight}
                    size={1}
                    className={`icon-subcategory-${rowData.level}`}
                /> */}
                <span>
                    {rowData.name}
                </span>
            </div>
            )

        if(rowData.children) {
            rowData.children.map((childrenData, index) => {
                this.renderCategoryItem(childrenData)
            })
        }
    }

    handleShowCategories = () => {
        this.setState({
            categoryMenu: !this.state.categoryMenu
        })
    }

    handleChagePrice = () => {

        let priceFrom = 0
        let priceTo = 0
        let price = [];
        if(!isNaN(this.price_from.state.value)) {
            priceFrom = this.price_from.state.value
            if(!priceFrom) {
                priceFrom = ""
            }
        }

        if(!isNaN(this.price_to.state.value)) {
            priceTo = this.price_to.state.value
            if(!priceTo) {
                priceTo = ""
            }
        }

        price[0] = priceFrom;
        price[1] = priceTo;

        this.addQueryToUrl("price", price)
    }

    //TODO - prichadza mi text a filter tagu funguje pomocou cilsa
    handleChangeOptionTag = (event) => {
        let tags = toJS(this.props.internal.dataForTable.lists.tags)
        this.setState({name: event.target.value})

        let number_of_ids = event.target.value.length
        let tmp = event.target.value[number_of_ids-1]

        let tag = tags.filter(function(tag) {
            if(tag.title === tmp) {
                return tag
            }
        })

        let ids = this.state.tags_ids;
        let idIsInArray = false


        for(let i=0; i<ids.length; i++) {

            if( tag[0] && ids[i] === tag[0].id) {
                ids.splice(i-1, 1);
                idIsInArray = true;
                break;
            }
        }
        if(!idIsInArray && tag[0]) {
            ids.push(tag[0].id)
        }

        if(!idIsInArray && !tag[0]) {
            ids = []
        }

        this.setState({tags_ids: ids}, () => {
            this.addQueryToUrl("tags", this.state.tags_ids)
        })

    }


    handleChangeOptionTag2 = (event) => {
        let tags = toJS(this.props.internal.dataForTable.lists.tags)
        this.setState({name: event.target.value.title})

        let number_of_ids = event.target.value.length
        let tmp = event.target.value[number_of_ids-1]


        let tag = tags.filter(function(tag) {

            if(tag.title === tmp.title) {
                return tag
            }
        })


        let ids = this.state.tags_ids;
        let idIsInArray = false


        for(let i=0; i<ids.length; i++) {

            if( tag[0] && ids[i] === tag[0].id) {
                ids.splice(i-1, 1);
                idIsInArray = true;
                break;
            }
        }
        if(!idIsInArray && tag[0]) {
            ids.push(tag[0].id)
        }

        if(!idIsInArray && !tag[0]) {
            ids = []
        }


        this.setState({tags_ids: ids}, () => {
            this.addQueryToUrl("tags", this.state.tags_ids)
        })

    }

    handleChangeOptionTag3 = (event) => {
        this.setState({tag:event.target.value })
        this.addQueryToUrl("tags", event.target.value)
    }

    handleChangeOptionStatus = (event) => {
        this.setState({warehouse_status_id:event.target.value })
        this.addQueryToUrl("warehouse_status_id", event.target.value)
    }

    handleChangeOptionImport = (event) => {
        // let import_id = event.target.value.split(',')[0]
        this.setState({import_id: event.target.value})
        this.addQueryToUrl("import_id", event.target.value)
    }

    handleChangeCategory = (rowId) => {
        this.addQueryToUrl("category_id", rowId)
        if(this.state.mobileCategoryList) {
            this.setState({mobileCategoryList: false})
        }
        this.flagCategorySet = false;
        if(rowId === "" ) {
            this.setState({activeCategoryMobile: ""})
        }
    }

    getStyles(id, that) {
        return {
          fontWeight:
            that.state.tags_ids.indexOf(id) === -1
              ? 400
              : 500
        };
      }

    handleClickCloseCategoryTagDialog = () => {
        this.setState({openCategoryTagDialog: false, dialogType: null})
    }

    handleClickOpenDialog = (type) => {
        this.setState({openCategoryTagDialog: true, dialogType: type})
    }

    handleClickOpenXmlExportDialog = () => {
        this.setState({openXmlExportDialog: !this.state.openXmlExportDialog})
    }

    handleExport = () => {
        api({
            method: 'get',
            url: 'products/export',
            authorization: this.props.internal.user.access_token,
        }).then(result => {
            if (true === result.success) {
                window.open(result.data.data.link, '_blank');
            }
        });
    }

    handleClickOpenChangeProductionDialog = () => {
        this.setState({isProductionDialogOpened: true});
    }
    saveMassProduction = async() => {
        let endpoint = '';

        if (true === this.state.productionDialogStatus) {
            endpoint = 'activate';
        } else {
            endpoint = 'deactivate';
        }

        if ('shops_production' === this.state.productionDialogType) {
            endpoint = `shops-${endpoint}`;
        }

        endpoint = `products/${endpoint}`;

        let response = await api({
            method: 'patch',
            url: endpoint,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: toJS(this.props.internal.checkedRows)
            }
        });

        if(response.success === true) {
            this.setState({loading: true})
            this.props.internal.setSnackbar(response.data.message, true)
            this.loadProducts()
            this.setState({
                productionDialogStatus: true,
                productionDialogType: 'production',
                isProductionDialogOpened: false,
            });
        }
    };

    showSnackbar = (message, open, dialog) => {
        this.setState({message: message, openSnackbar: open})
        // this.turnOffSnackBar()
        if(dialog) {
            this.setState({openCategoryTagDialog: false})
        }

    }

    closeDialog = (action) => {
        this.setState({openCategoryTagDialog: !action, isProductionDialogOpened: !action})
        if(action) {
            let emptyArr = []
            this.props.internal.setCheckedRows(emptyArr)
            this.setState({loading: true})
            this.loadProducts();
        }
    }

    handleCLickOnFloatButton = () => {
        this.setState({floatButton: !this.state.floatButton})
    }

    handleClickOpenMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
      };

      handleClickCloseMenu = () => {
        this.setState({ anchorEl: null });
      };

    handleShowMobileCategoryList = () => {
        this.setState({mobileCategoryList: !this.state.mobileCategoryList})
    }

    handleImportProducts = (action = false) => {
        this.setState({import: !this.state.import})
        if(action) {
            this.loadProducts();
        }
    }

    handlePriceImportProducts = (action = false) => {
        this.setState({priceImport: !this.state.priceImport})
        if(action) {
            this.loadProducts();
        }
    }

    changeProductionStatus = async(id, status) => {

        let update_data = await api({
            method: 'patch',
            url: `products/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                production: status
            }
        })

        if(update_data.success === true) {
            this.setState({loading: true})
            await this.loadProducts()
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    changeShopsProductionStatus = async(id, status) => {
        let update_data = await api({
            method: 'patch',
            url: `products/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                shops_production: status
            }
        })

        if(update_data.success === true) {
            this.setState({loading: true})
            await this.loadProducts()
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    handleDeleteProduct = async() => {
        this.props.internal.setActionDelete();
        this.deleteProduct(this.props.internal.actionDeleteObj.id)
    }

    deleteProduct = async (idProduct) => {
        let delete_data = await api({
            method: 'patch',
            url: 'products/' + idProduct,
            authorization: this.props.internal.user.access_token,
            params: {
                hidden: true
            }
        })

        if (delete_data.success && delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadProducts()
        }
        else {
            this.props.internal.setSnackbar(delete_data.data.message, true)
        }
    }

    addToShoppingCart = async(id) => {
        this.props.internal.setLoader({loading: true, id: id});
        // this.setState({loadingBtn: true})
        // let itemId = toJS(this.props.internal.dataForSimpeTable.id)
        let load_data = await api({
            method: 'put',
            url: 'shopping-cart',
            authorization: this.props.internal.user.access_token,
            params: {
                product: id,
                quantity: 1
            }
        })

        if(load_data.success === true) {
            this.props.internal.setSnackbar(load_data.data.message, true)
            // this.setState({message: load_data.data.message, openSnackbar: true})
            // this.turnOffSnackBar();
            // this.getShoppingCart();
          this.props.internal.addToShoppingCart(load_data.data.data.items);
          this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
            this.props.internal.setLoader({loading: false, id: null});
            // this.setState({loadingBtn: false})
        }
    }

    getShoppingCart = async() => {
        let load_data = await api({
            method: 'get',
            url: 'shopping-cart',
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.props.internal.addToShoppingCart(load_data.data.data.items);
            this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
        }
    }

    categoriesTree = []
    tmpChildrens = []
    index = 0

    setCategoriesTree (categories) {
        for(let i=0; i<categories.length; i++) {
            categories[i].key = categories[i].id
            categories[i].label = categories[i].name
            categories[i].value = categories[i].name
            if(categories[i].children.length > 0) {
                categories[i].nodes = []
                this.index = i
                if(categories[this.index] !== undefined && categories[this.index].hasOwnProperty("nodes")) {
                    categories[this.index].nodes = categories[this.index].children
                    // this.index =  0
                }

                if(this.index === categories.length - 1) {
                    this.index = 0
                }
                this.setCategoriesTree(categories[i].children)
                // this.categoriesTree.push({value: categories[i].name, nodes: []})
            }
            else {
                // this.categoriesTree.push({value: categories[i].name})
            }


        }
        this.categoriesTree = categories
    }

    onLeafClick = (data) => {
        this.activeItem = data.key
        this.handleChangeCategory(data.id)
    }

    activeItem = ""

    handleClickAllChangeProduction = async(status) => {

            let url = ""
            if(status === false ){
                url = 'products/deactivate'
            }else if (status === true) {
                url = 'products/activate'
            }
            let update_data = await api({
                method: 'patch',
                url: url,
                authorization: this.props.internal.user.access_token,
                params: {
                    ids: toJS(this.props.internal.checkedRows)
                }
            })

            if(update_data.success === true) {
                this.setState({loading: true})
                this.props.internal.setSnackbar(update_data.data.message, true)
                this.loadProducts()
            }
        }

    toggleProductsMenu = (productsActionAnchorEl) => {
        this.setState({ productsActionAnchorEl })
    }

    render() {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)

        let permissions;
        let importsArrayOfObjects = [];

        let tagsForMountSet = [] //ak url obsahuje niejake tagy

        if(!this.state.loading) {
            let imports = toJS(this.props.internal.dataForTable.filters.import_id[0].items)
            var res = Object.entries(imports).map(([k, v]) => ([Number(k), v]));
            for(let i = 0; i< res.length; i++) {
                let tmp = { id:  res[i][0], value:  res[i][1]}
                importsArrayOfObjects.push(tmp)
            }

            let tags = toJS(this.props.internal.dataForTable.lists.tags)

            let tagsFromUrl
            if(queries.tags) {
                tagsFromUrl = queries.tags.split(',')

                for(let i=0; i< tags.length; i++) {
                    for(let j=0; j<tagsFromUrl.length; j++) {
                        if(tags[i].id === Number(tagsFromUrl[j])) {
                            // tagsForMountSet.push(tags[i].title)
                            tagsForMountSet.push(tags[i])
                        }
                    }
                }
            }

            permissions = toJS(this.props.internal.user.data.permissions.products)
        }




        return (
            <div>
                {this.state.loading
                ?
                null
                :
                <div className={`categories-menu-${this.state.categoryMenu} flex`}>
                    <div className={'header'}>
                        <span>
                            { this.props.translate.i18n.GLOBAL.MENU.CATEGORIES }
                        </span>
                        <div onClick={this.handleShowCategories}>
                            {this.state.categoryMenu
                            ?
                                <Icon path={mdiChevronLeft} size = {1}/>
                                :
                                <Icon path={mdiChevronRight} size = {1}/>
                            }
                        </div>
                    </div>
                    <div className={`categories-list`} id={'categories-list'}>
                    {this.state.categoryMenu
                        ?
                        // this.renderCategoryList()
                        <MuiThemeProvider theme={theme}>
                            {/* <MuiTreeView tree={this.categoriesTree} onClickItem={this.onLeafClick}>
                            </MuiTreeView> */}
                            <TreeMenu data={this.categoriesTree} onClickItem={this.onLeafClick} activeKey={this.activeItem} initialOpenNodes={["Beko", "novy alias"]} />
                        </MuiThemeProvider>
                        // null
                        :
                        null
                    }

                    </div>
                </div>
            }
            {this.state.mobileCategoryList ?
                <div className={'mobile-categories-list'}>
                    {this.renderCategoryList()}
                    <div onClick={this.handleShowMobileCategoryList} className={'close'}>
                        <Icon path={mdiClose} size={1}  />
                    </div>
                </div>
                :
                null
            }
                <div className={'products-list-container'}>
                <div className={'products-list'}>
                {
                    this.state.loading
                    ?
                        <CircularProgress className = {'circular-progress'}/>
                        :
                        <div>
                            <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                            {this.state.openCategoryTagDialog ?
                                <AddCategoryOrTag
                                    open={this.state.openCategoryTagDialog}
                                    onClose={this.handleClickCloseCategoryTagDialog}
                                    title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_USER_DIALOG_TITLE}
                                    routerData={this.props.routerData}
                                    dialogType={this.state.dialogType}
                                    categories={toJS(this.props.internal.dataForTable.lists.categories)}
                                    tags={toJS(this.props.internal.dataForTable.lists.tags)}
                                    closeDialog={this.closeDialog}
                                />
                                :
                                null
                            }
                            {this.state.openXmlExportDialog ?
                                <AddToXmlExports
                                    open={this.state.openXmlExportDialog}
                                    onClose={this.handleClickOpenXmlExportDialog}
                                    title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_USER_DIALOG_TITLE}
                                    routerData={this.props.routerData}
                                    xmlExports={toJS(this.props.internal.dataForTable.lists.xml_exports)}
                                    closeDialog={this.closeDialog}
                                />
                                :
                                null
                            }
                            <Dialog
                                open={this.state.isProductionDialogOpened}
                                onClose={() => this.setState({isProductionDialogOpened: false})}
                                >
                                <DialogTitle>{this.props.translate.i18n.GLOBAL.DIALOGS.PRODUCTS.PRODUCTION}</DialogTitle>
                                <DialogContent>
                                    <Select
                                        value={this.state.productionDialogType}
                                        className={'stretch mb-10'}
                                        inputProps={{id: 'production-type'}}
                                        onChange={(event) => this.setState({productionDialogType: event.target.value})}
                                    >
                                        <MenuItem key={'production'} value={'production'}>{this.props.translate.i18n.MODULES.PRODUCTS.B2B_PRODUCTION}</MenuItem>
                                        <MenuItem key={'shops_production'} value={'shops_production'}>{this.props.translate.i18n.MODULES.PRODUCTS.SHOPS_PRODUCTION}</MenuItem>
                                    </Select>
                                    <Select
                                        value={this.state.productionDialogStatus}
                                        className={'stretch'}
                                        inputProps={{id: 'production-status'}}
                                        onChange={(event) => this.setState({productionDialogStatus: event.target.value})}
                                    >
                                        <MenuItem key={'production-on'} value={true}>{this.props.translate.i18n.GLOBAL.MENU.PRODUKOVAT}</MenuItem>
                                        <MenuItem key={'production-off'} value={false}>{this.props.translate.i18n.GLOBAL.MENU.ODPRODUKOVAT}</MenuItem>
                                    </Select>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => this.setState({isProductionDialogOpened: false})} className={'gray-text'}>
                                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                                    </Button>
                                    <Button onClick={this.saveMassProduction} className={'orange-text'}>
                                        {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {this.props.internal.actionDelete ?
                                <DeleteDialog
                                    open={this.props.internal.actionDelete}
                                    title={this.props.translate.i18n.MODULES.PRODUCTS.DELETE_PRODUCT_TITLE}
                                    content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                                    btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                                    btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                                    delete={this.handleDeleteProduct}
                                />
                                :
                                null
                            }
                            {this.state.import ?
                                <ImportProducts
                                    open = {this.state.import}
                                    title={this.props.translate.i18n.MODULES.PRODUCTS.IMPORT_PRODUCTS_DIALOG_TITLE}
                                    onClose={this.handleImportProducts}
                                />
                                :
                                null
                            }
                            {this.state.priceImport ?
                                <PriceImportProducts
                                    open = {this.state.priceImport}
                                    title={this.props.translate.i18n.MODULES.PRODUCTS.PRICE_IMPORT_PRODUCTS_DIALOG_TITLE}
                                    onClose={this.handlePriceImportProducts}
                                />
                                :
                                null
                            }
                            <div className={'product-module-search-actions'}>
                                {/* MOBILE CATEGORY LIST */}
                                {/* <div className={'mobile-categories'}>


                                    {this.state.mobileCategoryList ?

                                        <div onClick={this.handleShowMobileCategoryList}>
                                            <Icon path={mdiClose} size={1}  />
                                        </div>
                                        :
                                        <CustomButton
                                            style={`btn-orange-bg border-radius-18 ${this.state.mobileCategoryList? ' open': ""}`}
                                            onClick={this.handleShowMobileCategoryList}
                                        >
                                            <span>K</span>
                                        </CustomButton>

                                    }
                                </div> */}
                                {/* MOBILE CATEGORY LIST */}
                                <Search placeholder={this.props.translate.i18n.MODULES.PRODUCTS.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm }/>
                                    <React.Fragment>
                                        <div className={'btns'}>
                                            {permissions.export ? (<CustomButton
                                              mystyle={'btn-orange-bg border-radius-18 category'}
                                              title={this.props.translate.i18n.GLOBAL.MENU.EXPORT}
                                              onClick={() => this.handleExport()}
                                            >
                                                <Icon path={mdiCloudUpload} size={1}/>
                                            </CustomButton>) : null}
                                            {permissions.import ? (<CustomButton
                                              mystyle={'btn-boulder-bg border-radius-18 upload'}
                                              title={this.props.translate.i18n.GLOBAL.BUTTONS.IMPORT}
                                              onClick={this.handleImportProducts}
                                            >
                                                <Icon path={mdiUpload} size={1}/>
                                            </CustomButton>) : null}
                                            {permissions.change_prices ? (<CustomButton
                                              mystyle={'btn-boulder-bg border-radius-18 upload'}
                                              title={this.props.translate.i18n.GLOBAL.BUTTONS.PRICE_IMPORT}
                                              onClick={this.handlePriceImportProducts}
                                            >
                                                <Icon path={mdiUpload} size={1}/>
                                            </CustomButton>) : null}
                                            {permissions.update && toJS(this.props.internal.checkedRows).length > 0 && (<CustomButton
                                              mystyle={'btn-boulder-bg border-radius-18 upload'}
                                              title={this.props.translate.i18n.MODULES.PRODUCTS.ACTIONS}
                                              onClick={event => this.toggleProductsMenu(event.currentTarget)}
                                            >
                                                <Icon path={mdiSettings} size={1}/>
                                            </CustomButton>)}
                                        </div>
                                        {permissions.update ? (<Menu
                                          open={Boolean(this.state.productsActionAnchorEl)}
                                          anchorEl={this.state.productsActionAnchorEl}
                                          onClose={() => this.toggleProductsMenu()}
                                        >
                                            {permissions.change_production ? <MenuItem onClick={() => {this.toggleProductsMenu(); this.handleClickOpenChangeProductionDialog()}} className={'product-menu-item'}>
                                                <IconButton>
                                                    <Icon path={mdiCloudUpload} size={1}/>
                                                </IconButton> {this.props.translate.i18n.MODULES.PRODUCTS.DO_PRODUCTION}
                                            </MenuItem> : null}
                                            {permissions.pair_categories ? <MenuItem onClick={() => {this.toggleProductsMenu();this.handleClickOpenDialog('category')}} className={'product-menu-item'}>
                                                <IconButton>
                                                    <CategoriesIcon/>
                                                </IconButton> {this.props.translate.i18n.MODULES.PRODUCTS.DO_CATEGORIES}
                                            </MenuItem> : null}
                                            {permissions.pair_tags ? <MenuItem onClick={() => {this.toggleProductsMenu();this.handleClickOpenDialog('tag')}} className={'product-menu-item'}>
                                                <IconButton>
                                                    <Icon path={mdiLabel} size={1}/>
                                                </IconButton> {this.props.translate.i18n.MODULES.PRODUCTS.DO_TAGS}
                                            </MenuItem> : null}
                                            {permissions.pair_xml_exports ? <MenuItem onClick={() => {this.toggleProductsMenu();this.handleClickOpenXmlExportDialog()}} className={'product-menu-item'}>
                                                <IconButton>
                                                    <Icon path={mdiXml} size={'0.8em'}/>
                                                </IconButton> {this.props.translate.i18n.MODULES.PRODUCTS.DO_XML_EXPORTS}
                                            </MenuItem> : null}
                                        </Menu>) : null}
                                    </React.Fragment>
                            </div>
                            {/* MOBILE CATEGORIES "BUTTON" */}
                            <div onClick={this.handleShowMobileCategoryList} className={'categories-btn-2'}>
                                <span>
                                    { this.props.translate.i18n.GLOBAL.MENU.CATEGORIES }
                                    <Icon path={mdiChevronRight} size = {1} style={{verticalAlign: "bottom"}}/>
                                    {this.state.activeCategoryMobile}
                                </span>
                                    {/* {this.state.categoryMenu
                                    ?
                                        <Icon path={mdiChevronRight} size = {1}/>
                                        :
                                        <Icon path={mdiChevronLeft} size = {1}/>
                                    } */}
                            </div>
                            {/* MOBILE CATEGORIES "BUTTON" */}
                            <div className={'flex filters'}>
                            <Grid container>
                            <Grid item xs={6} sm>
                                <CustomInput
                                    ref={ref => this.price_from = ref}
                                    text={this.props.translate.i18n.MODULES.PRODUCTS.PRICE_FROM}
                                    value={this.state.priceFrom ? this.state.priceFrom : ""}
                                    id={'price_from'}
                                    className={"mr-10 text-right"}
                                    change={this.handleChagePrice}
                                    moreClasses={'min-width-200 price'}
                                    endAdornment={{position: "end", value: "€"}}
                                />
                                </Grid>
                                <Grid item xs={6} sm>
                                <CustomInput
                                    ref={ref => this.price_to = ref}
                                    text={this.props.translate.i18n.MODULES.PRODUCTS.PRICE_TO}
                                    value={this.state.priceTo ? this.state.priceTo : ''}
                                    id={'price_to'}
                                    className={"mr-10 text-right"}
                                    change={this.handleChagePrice}
                                    moreClasses={'min-width-200 price'}
                                    endAdornment={{position: "end", value: "€"}}
                                />
                                </Grid>
                                <Grid item xs={12} sm>
                                <FormControl className='tags-selector min-width-200'>
                                    <InputLabel htmlFor="select-multiple-chip" className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.SELECT_BY_TAG}</InputLabel>
                                    <Select
                                        className={'multiple-select '}
                                        value={this.state.tag ? this.state.tag : ""}
                                        onChange={this.handleChangeOptionTag3}
                                        inputProps={{
                                        name: 'tags',
                                        id: 'select-multiple-chip',
                                        }}
                                    >
                                    <MenuItem value="" className={'popup-menu'}>Všetky</MenuItem>
                                    {toJS(this.props.internal.dataForTable.lists.tags).map(name => (
                                        // <MenuItem key={name.id} value={name} title={name.title} >
                                        <MenuItem key={name.id} value={name.id} style={this.getStyles(name.id, this)}>
                                            {name.title}
                                        </MenuItem>
                                    ))}
                                    </Select>
                                </FormControl>
                                </Grid>
                                <Grid item xs={12} sm>
                                <TextField
                                    className={'custom-select mr-10 min-width-200'}
                                    id="standard-select-currency-native"
                                    select
                                    label={this.props.translate.i18n.MODULES.PRODUCTS.SELECT_BY_STATUS}
                                    // helperText={this.props.translate.i18n.MODULES.PRODUCTS.SELECT_BY_STATUS}
                                    value={this.state.warehouse_status_id ? this.state.warehouse_status_id : ""}
                                    onChange={this.handleChangeOptionStatus}
                                    // SelectProps={{
                                    //     native: true,
                                    // }}
                                >
                                    <MenuItem value="">Všetky</MenuItem>
                                    {toJS(this.props.internal.dataForTable.lists.warehouse_status).map((option) => {
                                        return(
                                            <MenuItem key={option.title} value={option.id}>
                                                {this.props.translate.i18n.MODULES.PRODUCTS[option.title.toUpperCase()]}
                                            </MenuItem>
                                        )
                                    })}
                                </TextField>
                                </Grid>
                                {permissions.update && permissions.store
                                    ?
                                    <Grid item xs={12} sm>
                                    <TextField
                                        className={'custom-select min-width-200'}
                                        id="standard-select-currency-native"
                                        select
                                        label={this.props.translate.i18n.MODULES.PRODUCTS.SELECT_BY_IMPORT}
                                        value={this.state.import_id}
                                        onChange={this.handleChangeOptionImport}
                                        >
                                        <MenuItem value=""><em>Všetky</em></MenuItem>
                                        {importsArrayOfObjects.map((option, index) => {
                                            return(
                                                <MenuItem key={option.id} value={option.id}>
                                                    {moment(option.value).format("DD.MM.YYYY HH:mm")}
                                                </MenuItem>
                                            )
                                        })}
                                    </TextField>
                                    </Grid>
                                    :
                                    null
                                }
                            </Grid>
                            </div>
                                {/*<div className={`mobile-action-${Number(toJS(this.props.internal.checkedRows).length) > 0 ? 'show': 'hidden' }`}>*/}
                                {/*        <CustomButton*/}
                                {/*            mystyle={'btn-orange-bg border-radius-18 category'}*/}
                                {/*            title={this.props.translate.i18n.GLOBAL.MENU.PRODUCTION}*/}
                                {/*            onClick={() => this.handleClickOpenChangeProductionDialog}*/}
                                {/*            disabled={toJS(this.props.internal.checkedRows).length ? false : true}*/}
                                {/*        >*/}
                                {/*        <Icon path={mdiCloudUpload} size={1}  />*/}
                                {/*        </CustomButton>*/}
                                {/*    <CustomButton*/}
                                {/*            mystyle={'btn-orange-bg border-radius-18 category'}*/}
                                {/*            title={this.props.translate.i18n.GLOBAL.MENU.CATEGORIES}*/}
                                {/*            onClick={() => this.handleClickOpenDialog('category')}*/}
                                {/*            disabled={toJS(this.props.internal.checkedRows).length ? false : true}*/}

                                {/*        >*/}
                                {/*            <CategoriesIcon/>*/}
                                {/*        </CustomButton>*/}
                                {/*        <CustomButton*/}
                                {/*            mystyle={'btn-orange-bg border-radius-18 tag'}*/}
                                {/*            title={this.props.translate.i18n.GLOBAL.MENU.TAGS}*/}
                                {/*            onClick={() => this.handleClickOpenDialog('tag')}*/}
                                {/*            disabled={toJS(this.props.internal.checkedRows).length ? false : true}*/}
                                {/*        >*/}
                                {/*            <Icon path={mdiLabel} size={1}  />*/}
                                {/*        </CustomButton>*/}
                                {/*</div>*/}
                                <CustomTable
                                    dropDownMenuItems = {this.dropDownMenuItems}
                                    module = {'/products'}
                                    handleChangeRowsPerPage = {this.handleChangeRowsPerPage}
                                    handleChangePage = {this.handleChangePage}
                                    handleSort = {this.handleSort}
                                    header = {this.tableHeader}
                                    body = {this.tableBody}
                                    firstCellCheckbox={permissions.update ? true : false}
                                    clickOnProductionStatus={permissions.change_production ? this.changeProductionStatus : () => {}}
                                    clickOnShopsProductionStatus={permissions.change_production ? this.changeShopsProductionStatus : () => {}}
                                    showAllClientPrices
                                    addToShoppingCart={this.addToShoppingCart}
                                />


                        </div>
                    }
                </div>
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/list/index.js